import React from "react";
import {Control} from "react-hook-form";
import {Grid, Typography} from "@mui/material";
import {FormInputSelect} from "../../shop/wholesale/form/FormInputSelect";
import {ShippingCarrierFormData} from "./ShippingCarrierForm";
import {FormInputCheckbox} from "../../shop/wholesale/form/FormInputCheckbox";
import {FormInputSecret} from "../../shop/wholesale/form/FormInputSecret";

interface CarrierGatewayEditorProps {
   control: Control<ShippingCarrierFormData>;
}

export const CarrierGatewayEditor: React.FC<CarrierGatewayEditorProps> = ({control}) => {
   return (
      <div>
         <Typography variant="h2" gutterBottom>
            Carrier Gateway Integration
         </Typography>

         <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
               <FormInputSecret name="carrierGateway.apiKey" label="Api KEY"/>
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputCheckbox name="carrierGateway.supportQR" label="Generates QR codes"/>
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputSelect
                  name="carrierGateway.inputCarrier"
                  label="Input Carrier"
                  options={[
                     {id: 'DHL_EXPRESS', name: 'DHL Express'},
                     {id: 'GLS', name: 'GLS'}
                  ]}
               />
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputSelect
                  name="carrierGateway.outputCarrier"
                  label="Output Carrier"
                  options={[
                     {id: 'b2c_europe', name: 'B2C Europe'},
                     {id: 'dao', name: 'DAO'},
                     {id: 'deutsche_post', name: 'Deutsche Post'},
                     {id: 'dhl', name: 'DHL'},
                     {id: 'dhl_express', name: 'DHL Express'},
                     {id: 'gls', name: 'GLS'},
                     {id: 'parcelplus', name: 'ParcelPlus'},
                     {id: 'pdk', name: 'PDK'},
                     {id: 'ups', name: 'UPS'}
                  ]}
               />
            </Grid>
         </Grid>
      </div>
   );
};